import {NgModule} from '@angular/core';
import {SpecialistListComponent} from './specialist-list/specialist-list.component';
import {SpecialistViewComponent} from './specialist-view/specialist-view.component';
import {SpecialistFormComponent} from './specialist-form/specialist-form.component';
import {SpecialistFormFieldsModule} from '../../subforms/specialist-form-fields/specialist-form-fields.module';
import {SharedModule} from '@helpers/modules/shared.module';
import {SpecialistViewModule} from '@modules/specialist-view/specialist-view.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {SpecialistService} from './services/specialist.service';
import {SpecialistsModule} from '@modules/specialists/specialists.module';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {SpecialistStatusFormComponent} from './specialist-status-form/specialist-status-form.component';
import {SpecialistResolverService} from './services/specialist-resolver.service';
import {IconsModule} from '@lab365/icons';
import { DownloadButtonComponent } from './components/download-button/download-button.component';
import {Lab365CommonModule} from '@lab365/common';

@NgModule({
    providers: [
        SpecialistService,
        SpecialistsResolverService,
        SpecialistResolverService,
    ],
    declarations: [
        SpecialistListComponent,
        SpecialistViewComponent,
        SpecialistFormComponent,
        SpecialistStatusFormComponent,
        DownloadButtonComponent,
    ],
    imports: [
        SharedModule,
        DirectivesModule,
        SpecialistFormFieldsModule,
        SpecialistViewModule,
        SpecialistsModule,
        IconsModule,
        Lab365CommonModule,
    ],
    exports: []
})
export class SpecialistPageModule {}
